import { ChevronRight } from 'lucide-react';

import { CATEGORY_META, dueLabel } from './practiceMeta';
import { PracticeItemLink } from './PracticeItemLink';

import type { PracticeItem } from '@/lib/api/lms';

/** One row in the Pending Work list and the category list: themed icon, title +
 *  module subtitle, and a right-aligned due/status indicator with a chevron. */
export function PracticeRow({ item, batchId }: { item: PracticeItem; batchId: string }) {
  const meta = CATEGORY_META[item.category];
  const Icon = meta.icon;
  const due = dueLabel(item.due_date);

  return (
    <PracticeItemLink
      item={item}
      batchId={batchId}
      className="flex items-center gap-4 px-5 py-4 transition-colors hover:bg-[#fafafa]"
    >
      <span className="flex size-11 shrink-0 items-center justify-center rounded-xl" style={{ background: meta.bg }}>
        <Icon className="size-5" style={{ color: meta.fg }} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-[15px] font-semibold text-[#111827]">{item.title}</p>
        <p className="truncate text-[13px] text-[#9ca3af]">{item.module_title}</p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {item.submitted ? (
          <span className="text-[13px] font-semibold text-[#16a34a]">Completed</span>
        ) : due ? (
          <span className={`text-[13px] font-semibold ${due.urgent ? 'text-[#ff5a1f]' : 'text-[#9ca3af]'}`}>
            {due.text}
          </span>
        ) : null}
        <ChevronRight className="size-4 text-[#d1d5db]" />
      </div>
    </PracticeItemLink>
  );
}
